import fetchAPI from "@/utils/fetch";
import consoleController from "@/utils/logUtil";

// web側からのイベントログ送信を管理する
// facecare-web-viewと共有するファイルのため、このファイルを変更する際はfacecare-web-viewの同名ファイルにも同じ変更を加える運用とする

/**
 * イベントログを登録する
 * @param accountId アカウントID
 * @param eventCode イベントコード
 * @param eventData イベントデータ
 * @returns Recommend1
 */
async function registerEvent(accountId, eventCode, eventData) {
  if (accountId === undefined) {
    consoleController(
      "log",
      "cannot registerEvent because accountId is undefined",
    );
    return;
  }
  eventData.userAgent = navigator.userAgent;
  eventData.languageCode = navigator.language || navigator.userLanguage;
  const { fetch } = fetchAPI;
  const path = "/web/event";
  const body = {
    accountId,
    eventCode,
    eventData,
  };
  await fetch.fetchAPI("POST", path, null, body);
}

function getEventCodeList() {
  return {
    viewed_page: "viewed_page",
    clicked_agree_term: "clicked_agree_term",
    clicked_registration: "clicked_registration",
    clicked_check: "clicked_check",
    clicked_AppStore: "clicked_AppStore",
    clicked_ignore: "clicked_ignore",
    clicked_skinconcerns: "clicked_skinconcerns",
    clicked_skintype: "clicked_skintype",
    clicked_playfrombegin: "clicked_playfrombegin",
    clicked_pauseandplay: "clicked_pauseandplay",
    clicked_audio: "clicked_audio",
    clicked_skin_analysis: "clicked_skin_analysis",
    clicked_analysis_start: "clicked_analysis_start",
    clicked_contents: "clicked_contents",
    clicked_scale_next: "clicked_scale_next",
    clicked_scale_previous: "clicked_scale_previous",
    swiped_scale_next: "swiped_scale_next",
    swiped_scale_previous: "swiped_scale_previous",
    controlled_app_start: "controlled_app_start",
    controlled_app_foreground: "controlled_app_foreground",
    controlled_push_notice_screen: "controlled_push_notice_screen",
    viewed_error: "viewed_error",
    feedback: "feedback",
  };
}

function getScreenIdList() {
  return {
    skinAnalysisResult: "300",
    skinAnalysisButton: "300E",
    recommendMachineForYou: "300H",
    skinAnalysisGraphDayAll: "302-1",
    skinAnalysisGraphDayItem: "302-2",
    skinAnalysisGraphDaySelect: "302B",
    skinAnalysisGraphWeekAll: "303-1",
    skinAnalysisGraphWeekItem: "303-2",
    skinAnalysisGraphWeekScroll: "303C",
    skinAnalysisGraphMonthAll: "304-1",
    skinAnalysisGraphMonthItem: "304-2",
    skinAnalysisGraphMonthScroll: "304C",
    skinAnalysisGraphSixMonthsAll: "305-1",
    skinAnalysisGraphSixMonthsItem: "305-2",
    skinAnalysisGraphSixMonthsScroll: "305C",
    skinAnalysisBrowserTutorialAppUser: "400-1",
    skinAnalysisBrowserTutorialBrowserUser: "400-2",
    skinAnalysisBrowserLoading: "401-1",
    skinAnalysisBrowserCameraPermissionConfirmation: "401-2",
    skinAnalysisBrowserCameraPermissionDenied: "401-3",
    skinAnalysisBrowserCapture: "402",
    skinAnalysisBrowserCapturing: "403",
    skinAnalysisBrowserAnalyzing: "404",
    skinAnalysisBrowserResultWithImage: "405",
    skinAnalysisBrowserSkinAnalysisButton: "405E",
    skinAnalysisBrowserAppDownloadPromotion: "407",
    skinAnalysisBrowserAppDownloadPromotionAppStoreButton: "407A",
    skinAnalysisBrowserUnsupportedDeviceGuide: "408",
    skinAnalysisBrowserPerfectPrivacyConsent: "409",
    skinAnalysisBrowserMaintenance: "410",
    serviceTopLink: "700A",
    serviceSalonLink: "700B",
    serviceTutorialVideoLink: "700C",
    serviceFeatureLink: "700D",
    servicePanasonicBeautyLink: "700E",
  };
}

export default {
  registerEvent,
  getEventCodeList,
  getScreenIdList,
};
